module.exports = __webpack_public_path__ + "static/media/monoful-brand.38d521b6.svg";